module.exports = __webpack_public_path__ + "img/wpibuild.80795552.jpg";